var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Logo',{attrs:{"show":false,"isSwitchLanguage":true}}),_c('Cover'),_c('Intro'),_c('Destination'),_c('Enquiry'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }